export enum SystemNodeType {
    START = 'start',
    END = 'end',
    ROLTEK_PRODUCTION = 'roltek_production',
}
